import Constant from '@/common/constant/Constant';
import { I18n } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { findLastIndex } from 'lodash';

export default function MessageConnecting({ messages,isModePreview }) {
    const [isShowConnectingMessage, setIsShowConnectingMessage] = useState(false);

    useEffect(() => {
        let indexOfSentFormMessage = findLastIndex(messages, message => {
            return message.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONTENT_QA_CHATBOT &&
            message.anonymousType === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT
        });
        if(indexOfSentFormMessage !== -1){
            if(indexOfSentFormMessage === messages.length -1){
                setIsShowConnectingMessage(true);
            }else{
                let isConnecting = true;
                for (let i = indexOfSentFormMessage + 1;i<messages.length; i++) {
                    if(!messages[i].isFromMe) isConnecting = false
                }
                setIsShowConnectingMessage(isConnecting)
            }
        } else {
            if (isModePreview) {
                setIsShowConnectingMessage(false)
            }
        }
    },[messages])
   
    if (isShowConnectingMessage) {
        return (
            <div className="message-connecting">
                <div className="loading-message">
                    <div className="dot-chatbot dot--one"></div>
                    <div className="dot-chatbot dot--two"></div>
                    <div className="dot-chatbot dot--three"></div>
                </div>
                <div>{I18n.get('CBOTMSG016')}</div>
            </div>
        );
    }
    return null;
}